import React from "react";
import { twMerge } from "tailwind-merge";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import {
  EditOutlined,
  ToggleOff,
  ToggleOn,
  VisibilityOutlined,
} from "@mui/icons-material";

const ListOptionItem = ({
  isBusy = false,
  isActive = false,
  listOption,
  onViewSubOptions,
  onSelectOption,
  onToggleOptionStatus,
}) => {
  return (
    <div className="flex select-none items-center justify-between space-x-10 px-4 py-3">
      <div className="flex-grow">{listOption?.name}</div>

      {!!listOption?.group && (
        <div className="px-2 py-0.5 text-xs font-medium uppercase tracking-widest text-blue-600 dark:text-blue-200">
          {listOption?.group}
        </div>
      )}

      <div
        className={twMerge(
          "rounded px-2 py-0.5 text-sm",
          isActive ? "bg-green-50 text-green-500" : "bg-red-50 text-red-500"
        )}
      >
        {isActive ? "Active" : "Inactive"}
      </div>

      {!!listOption?.value && (
        <div className="w-30 flex-shrink-0 text-center">
          <div
            className={twMerge(
              "font-medium",
              listOption?.valueType === "Number" && +listOption?.value > 0
                ? "text-green-600 dark:text-green-200"
                : "text-red-600 dark:text-red-200"
            )}
          >
            {listOption?.value}
          </div>

          <div className="text-[12px] text-gray-500">
            {listOption?.valueLabel}
          </div>
        </div>
      )}

      <div className="flex flex-shrink-0">
        {listOption?.level < listOption?.maxLevel && (
          <IconButton
            disabled={isBusy}
            onClick={() => onViewSubOptions(listOption)}
          >
            <Tooltip title="View Sub Options" arrow placement="top">
              <VisibilityOutlined fontSize="small" />
            </Tooltip>
          </IconButton>
        )}

        <IconButton
          disabled={isBusy}
          onClick={() => onSelectOption(listOption)}
        >
          <Tooltip title="Edit" arrow placement="top">
            <EditOutlined fontSize="small" />
          </Tooltip>
        </IconButton>

        <IconButton
          disabled={isBusy}
          onClick={() => onToggleOptionStatus(listOption)}
        >
          {!isBusy ? (
            <Tooltip
              title={!isActive ? "Deactivate" : "Active"}
              arrow
              placement="top"
            >
              {isActive ? (
                <ToggleOn color="success" />
              ) : (
                <ToggleOff color="error" />
              )}
            </Tooltip>
          ) : (
            <CircularProgress size={24} />
          )}
        </IconButton>
      </div>
    </div>
  );
};

export default ListOptionItem;
